<template>
  <div>
    <v-expansion-panel v-for="(logGroups, name, index) in logsGroupByProcessId" :key="index" color="primary" class="execution-logs mt-1">
      <v-expansion-panel-content>
        <template v-slot:header>
          <v-flex md6>
            <strong> Process id:</strong>&ensp; {{ name }}
          </v-flex>
          <v-flex md6>
            <strong> Date:</strong>&ensp; {{ getDate(logGroups) }}
          </v-flex>
        </template>
        <v-expansion-panel expand dark>
          <LogContent v-for="(logs, i) in logGroups" :key="i" :log="logs" />
        </v-expansion-panel>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
  import LogContent from '../LogContent'
  import { groupLogsByProcessInstanceId } from '../../Helpers/Logs'
  import moment from 'moment'
  import { prettyDateTimeFormat } from '@/components/mixins/MomentUtil'
  export default {
    components: {
      LogContent,
    },
    props: {
      logs: Array,
    },
    computed: {
      logsGroupByProcessId() {
        if (this.logs) return groupLogsByProcessInstanceId(this.logs)
        else return {}
      },      
    },
    methods: {
      getDate(grouping) {
        if(grouping != null && grouping[0]._source != null) {
          let date = moment(grouping[0]._source.ExecutionDate)
          return date.format(prettyDateTimeFormat)
        }
        return 'Unknown'
        
      },
    },
  }
</script>
<style>
  .execution-logs>.layout.row.wrap {
    text-shadow: 0px 0px 4px black !important;
  }
</style>
